import { render, staticRenderFns } from "./myCommunityList.vue?vue&type=template&id=164b7459&scoped=true"
import script from "./myCommunityList.vue?vue&type=script&lang=js"
export * from "./myCommunityList.vue?vue&type=script&lang=js"
import style0 from "./myCommunityList.vue?vue&type=style&index=0&id=164b7459&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164b7459",
  null
  
)

export default component.exports